import {
    FETCH_RESULTS_LIST,
    FETCH_FILTER_OPTIONS,
    INITIAL_RESULT_STATE_DATA,
    FETCH_COMPLEX_TYPE,
    FETCH_SPECIES_TYPE,
    UPDATE_RESULT_STATE,
    UPDATE_RESULT_STATE_FILTERS,
    FETCH_RESULT_DATA,
    FETCH_RESULT_BIOME_DATA,
    DELETE_RESULT,
    DELETE_MULTIPLE_RESULTS,
    FETCH_BATCH_NUMBERS,
} from "../actions/types"

const initial = {
    filterBuildingList: [],
    filterFloorList: [],
    filterSampleTypeList: [],
    filterAnalysisList: [],
    fromDate: null,
    toDate: null,
    filterLocationList: [],
    filterOrganismList: [],
    filterSequenceList: [],
    filterReferenceGenomeList: [],
    filterSnpDistanceList: [],
    filterComplexList: [],
    filterNovelList: [],
    filterBatchList: [],
    buildingFilter: [],
    floorFilter: [],
    batchFilter: [],
    locationFilter: [],
    organismFilter: [],
    complexFilter: [],
    novelFilter: [],
    sequenceFilter: [],
    sampleTypeFilter: [],
    analysisFilter: [],
}
const INITIAL_STATE = {
    downloadResultData:[],
    downloadBiomeResultData:[],
    resultsList: [],
    filters: [],
    allPagination: {
        currentPage: 1,
        totalPages: 0
    },
    complexList: [],
    speciesList: [],
    batchNoList: [],
    searchResult: "",
    initialState: {
        filterBuildingList: [],
        filterFloorList: [],
        filterSampleTypeList: [],
        filterAnalysisList: [],
        fromDate: null,
        toDate: null,
        filterLocationList: [],
        filterOrganismList: [],
        filterSequenceList: [],
        filterReferenceGenomeList: [],
        filterSnpDistanceList: [],
        filterComplexList: [],
        filterNovelList: [],
        filterBatchList: [],
        buildingFilter: [],
        floorFilter: [],
        batchFilter: [],
        locationFilter: [],
        organismFilter: [],
        complexFilter: [],
        novelFilter: [],
        sequenceFilter: [],
        sampleTypeFilter: [],
        analysisFilter: [],
    },
    resultParams: {}
}
let calculateTotalPages = (totalCount, pageSize) => {
    return (totalCount && pageSize) ? (Math.floor(totalCount / pageSize) + (totalCount % pageSize ? 1 : 0)) : 1
}
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_RESULTS_LIST:
            return {
                ...state,
                resultsList: action.payload.hasOwnProperty('results') ? action.payload.results : action.payload,
                allPagination: {
                    currentPage: action.payload.current_page,
                    totalPages: calculateTotalPages(action.payload.total_count, action.payload.page_size)
                },
                resultParams: action.param
            }
        case FETCH_RESULT_DATA:
            return {
                ...state,
                downloadResultData: action.payload.hasOwnProperty('results') ? action.payload.results : action.payload
            }
        case FETCH_RESULT_BIOME_DATA:
            return {
                ...state,
                downloadBiomeResultData: action.payload.hasOwnProperty('results') ? action.payload.results : action.payload
            }
        case DELETE_RESULT:
            return {...state, downloadResultData: [...state.downloadResultData.filter( val=>val !== action.payload.data)]};
        case DELETE_MULTIPLE_RESULTS:
            return {...state, downloadResultData: [...state.downloadResultData.filter( val=> !action.payload.data.includes(val.id))]};
        case FETCH_FILTER_OPTIONS:
            return {
                ...state,
                filters: action.payload
            }
        case INITIAL_RESULT_STATE_DATA:
            return {
                ...state,
                initialState: initial,
                searchResult: ""
            }
        case FETCH_COMPLEX_TYPE:
            return {
                ...state,
                complexList: action.payload
            }
        case FETCH_SPECIES_TYPE:
            return {
                ...state,
                speciesList: action.payload
            }
        case FETCH_BATCH_NUMBERS:
            return {
                ...state,
                batchNoList: action.payload
            }
        case UPDATE_RESULT_STATE:
            return {
                ...state,
                searchResult: action.payload,
                initialState: initial
            }
        case UPDATE_RESULT_STATE_FILTERS:
            if (action.payload.value) {
                state.initialState = {
                    ...state.initialState,
                    [action.payload.name]: action.payload.value,
                    [action.payload.name2]: action.payload.value
                }
            }
            else {
                state.initialState = {
                    ...state.initialState,
                    [action.payload.name]: [],
                    [action.payload.name2]: []
                }
            }
            return {
                ...state,
                initialState: state.initialState,
                searchResult: ""
            }
        default:
            return state
    }
}